var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import { connect } from "react-redux";
import { get } from "lodash";
import idHelper from "@irati/utils/id";
import authentication from "@irati/auth";
import TenantHomePageQuery from "@irati/homepage/services/apollo/queries/TenantHomePage";
import tracking from "@irati-tracking/homepage";
import Layout from "../components/NewHomePage/ManageLayout/Layout";
import HomePageHeader from "../components/NewHomePage/Header";
import { HomePageView } from "../components/NewHomePage/types";
var EditHomePageV2 = /** @class */ (function (_super) {
    __extends(EditHomePageV2, _super);
    function EditHomePageV2(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangePageView = function (pageView) {
            tracking.homePageChangeView(pageView);
            _this.setState({ pageView: pageView });
        };
        _this.state = {
            pageView: props.isMobile ? HomePageView.EMPLOYEE_VIEW : HomePageView.EDIT_CONTENT_VIEW
        };
        return _this;
    }
    EditHomePageV2.prototype.render = function () {
        var pageView = this.state.pageView;
        var isMobile = this.props.isMobile;
        var getTenantHomePageVars = {
            isNative: false,
            tenantId: authentication.userTenant().uuid
        };
        var idNamespace = idHelper("HomePage", this.props, { force: true });
        var openModal = get(this.props, "location.state.openModal");
        return (React.createElement(Grid, null,
            !isMobile && React.createElement(HomePageHeader, { onChangePageView: this.onChangePageView, pageView: pageView, id: idNamespace }),
            React.createElement(TenantHomePageQuery, { variables: getTenantHomePageVars }, function (_a) {
                var data = _a.data;
                var companyNews = data.companyNews, layoutWidgets = data.layoutWidgets;
                if (pageView !== HomePageView.EDIT_LAYOUT_VIEW) {
                    return (React.createElement(Layout, { companyNews: companyNews, id: idNamespace, layoutWidgets: layoutWidgets, pageView: pageView, openModal: openModal }));
                }
            })));
    };
    return EditHomePageV2;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: get(mq, "lessThan.medium", false)
    };
};
export default connect(mapStateToProps)(EditHomePageV2);
